import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { Actions, Store, ofActionSuccessful } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Campaign } from 'src/app/models/campaign';
import { LoadCampaignsSuccess } from '../../../redux/campaign.actions';
import { CampaignState } from '../../../redux/campaign.state';
import { ViewCampaignComponent } from '../view-campaign.component';

@Component({
  selector: 'app-modal-container',
  template: ''
})
export class ModalContainerCampaignComponent implements OnDestroy, OnInit {
  // This is only used when you enter URL of specific campaign with ID.
  public campaign$: Observable<Campaign[] | undefined> = inject(Store).select(CampaignState.campaign);
  private unsubscribe = new Subject<void>();

  public tableData?: Campaign[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: NbDialogService,
    private actions$: Actions
  ) {}

  public ngOnInit() {
    this.campaign$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.tableData = data));
    this.route.params.pipe(takeUntil(this.unsubscribe)).subscribe((params) => {
      if (this.tableData) {
        const found = this.tableData.find((element) => element.id === params.id);
        if (found) {
          this.dialogService
            .open(ViewCampaignComponent, {
              closeOnEsc: false,
              closeOnBackdropClick: false,
              context: {
                campaign: found
              }
            })
            .onClose.subscribe(() => {
              this.router.navigateByUrl('campaigns/table');
            });
        }
      } else {
        this.actions$.pipe(ofActionSuccessful(LoadCampaignsSuccess), takeUntil(this.unsubscribe)).subscribe(() => {
          const found = this.tableData.find((element) => element.id === params.id);
          this.dialogService
            .open(ViewCampaignComponent, {
              closeOnEsc: false,
              closeOnBackdropClick: false,
              context: {
                campaign: found
              }
            })
            .onClose.subscribe(() => {
              this.router.navigateByUrl('campaigns/table');
            });
        });
      }
    });
  }

  public ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
